"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const Tab = props => {
  const {
    title,
    onClick,
    isSelected
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('tab', {
      'tab--selected': isSelected
    }),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('tab__bottom-line', {
      'tab__bottom-line--hidden': !isSelected
    })
  }), title);
};

Tab.propTypes = {
  isSelected: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired,
  title: _propTypes.default.string.isRequired
};
Tab.defaultProps = {
  isSelected: false
};
var _default = Tab;
exports.default = _default;